import React, { useState } from "react";
import { Form, Button, Select, DatePicker } from "antd";
import moment from "moment";
import ServiceApi from "../../services/ServiceApi";

const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
};

const tailLayout = {
  wrapperCol: { offset: 8, span: 16 },
};

const { Option } = Select;

const RepairPointReport = ({ areaCode }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [form] = Form.useForm();

  const handleSubmit = (value) => {
    // console.log("value", value);
    // console.log(
    //   "url",
    //   ServiceApi.absoluteApi(
    //     `repairpoint/export?areaId=${value.areaId ?? ""}&startDate=${moment(
    //       value.startDate
    //     ).format("YYYY-MM-DD 00:00:00")}&endDate=${moment(value.endDate).format(
    //       "YYYY-MM-DD 00:00:00"
    //     )}`
    //   )
    // );
    setIsLoading(true);
    window.open(
      ServiceApi.absoluteApi(
        `repairpoint/export?areaId=${value.areaId}&startDate=${moment(
          value.startDate
        ).format("YYYY-MM-DD 00:00:00")}&endDate=${moment(value.endDate).format(
          "YYYY-MM-DD 00:00:00"
        )}`
      )
    );

    setTimeout(() => {
      setIsLoading(false);
    }, 800);
  };
  return (
    <div>
      <Form
        {...layout}
        onFinish={handleSubmit}
        form={form}
        // layout="vertical"
        hideRequiredMark="true"
        initialValues={{
          startDate: moment(),
          endDate: moment(),
        }}
      >
        <Form.Item
          label="Area name"
          name="areaId"
          //   rules={[{ required: true, message: "Area name is required" }]}
        >
          <Select
            className="w-100"
            showSearch
            placeholder="Select area"
            // value={this.state.areaId}
            // onSelect={this.setArea}
          >
            <Option value="" className="default-thai-font">
              ALL Area
            </Option>
            <Option value="BK%" className="default-thai-font">
              ALL_BKK
            </Option>
            {areaCode.map((item, index) => (
              <Option value={item.area_code} key={index}>
                <span className="default-thai-font">{item.area_code}</span>
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          name="startDate"
          label="Start Date"
          rules={[
            {
              type: "object",
              required: true,
              message: "Start Date is required",
            },
          ]}
          className="for-got-password"
        >
          <DatePicker format={"YYYY-MM-DD"} style={{ width: 120 }} />
        </Form.Item>

        <Form.Item
          name="endDate"
          label="End Date"
          rules={[
            {
              type: "object",
              required: true,
              message: "End Date is required",
            },
          ]}
          className="for-got-password"
        >
          <DatePicker format={"YYYY-MM-DD"} style={{ width: 120 }} />
        </Form.Item>
        {/* <div className="row justify-content-md-center"> */}
        <Form.Item {...tailLayout}>
          <Button
            size="small"
            className="btn btn-xs"
            style={{
              //   display: "flex",
              alignItems: "center",
              padding: "0px 30px",
              width: 120,
              backgroundColor: "rgb(232, 236, 239)",
            }}
            onClick={() => form.resetFields()}
          >
            Clear
          </Button>
          <Button
            loading={isLoading}
            size="small"
            className="btn btn-xs btn-warning"
            style={{
              //   display: "flex",
              alignItems: "center",
              padding: "0px 30px",
              width: 120,
            }}
            onClick={() => form.submit()}
          >
            Submit
          </Button>
        </Form.Item>
        {/* </div> */}
      </Form>
    </div>
  );
};

export default RepairPointReport;
